import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-employee-attendence',
  templateUrl: './employee-attendence.component.html',
  styleUrls: ['./employee-attendence.component.css']
})
export class EmployeeAttendenceComponent implements OnInit {

  usersList: any= []
  status = ""
  userId = ""
  date1:any
  date2: any
  UserLoginData: any= []
  loginData: any = [];
  SingleUserData: any = [];
  userid: any = "";

  startTime: any = [];
  endTime: any = [];

  startDate: any = [];
  endDate: any = [];


  constructor(private toastr: ToastrService,private generic_service: GenericService) { }
  arr:any = [];

  ngOnInit(): void {
    this.arr = [];

    // this.getFilteredData()
    this.date1 = new Date()
    this.date1.setDate(this.date1.getDate());
    this.date1 = formatDate(this.date1, 'yyyy-MM-dd', 'en-US')
    this.getUserLoginData()
  }


  getUserLoginData(){

    let date = new Date(this.date1).getTime()

    this.generic_service.getUserAttendence(date).subscribe(
      (response:any)=>{
        console.log(response)
        this.UserLoginData = []
        this.UserLoginData = response.response
        for(let i=0; i<response.response.length; i++){
          this.arr = []
          for(let j=0; j<response.response[i].loginHistory.length; j++){
            this.arr.push(
              {
                status: String(response.response[i].loginHistory[j].startTime),
                type:"logged in"
              }
            )
            if(response.response[i].loginHistory[j].endTime != null && response.response[i].loginHistory[j].endTime != 'null'){
              this.arr.push(
                {
                  status: String(response.response[i].loginHistory[j].endTime),
                  type:"logged out"
                }
              )
            }
          }
          this.UserLoginData[i].loginHistory = this.arr
        }
        console.log(this.arr)
        this.UserLoginData = response.response
        console.log(this.UserLoginData)
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  getUserAttendenceById(id:any){
    this.userid = id
    let date = new Date(this.date1).getTime()

    this.generic_service.getUserAttendenceByUserIdAndDate(this.userid,date).subscribe(
      (response:any)=>{
        console.log(response)
        console.log(response.response)
        this.SingleUserData = []
        this.SingleUserData = response.response;
      },
      (error:any)=>{
        console.log(error)

      }
    )
  }

  currentStatus(status: any){
    if(status == "Start"){
      return "Active"
    }
    if(status == "Stop"){
      return "In-active"
    }
    return ""
  }


  calculateTimeDifference1(timestamp1: string, timestamp2: string): string {
    // Convert the string timestamps to numbers (assuming they are in milliseconds)

    if(timestamp1 != null && timestamp2 != null && timestamp1 != undefined && timestamp2 != undefined && timestamp1 != '' && timestamp2 != ''){
      return ''
    }
    const date1 = new Date(parseInt(timestamp1, 10));
    const date2 = new Date(parseInt(timestamp2, 10));

    // Calculate the difference in milliseconds
    const diffInMilliseconds = Math.abs(date2.getTime() - date1.getTime());

    // Convert milliseconds to hours, minutes, and seconds
    const hours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const minutes = Math.floor((diffInMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffInMilliseconds % (1000 * 60)) / 1000);

    // Format the result as HH:mm:ss
    const formattedTime = `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(seconds)}`;
    
    return formattedTime;
  }

  // Helper function to pad single digits with leading zeros
  padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }


}